import { render, staticRenderFns } from "./XferToSite.vue?vue&type=template&id=8f427f7c&"
import script from "./XferToSite.vue?vue&type=script&lang=js&"
export * from "./XferToSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports